const Style = {
    dropdown: 'p-2 bg-white border border-slate-200 rounded-2xl shadow-md min-w-[150px] transition-all duration-300 ease-in-out',
    item: 'p-2 my-1 hover:bg-slate-100 cursor-pointer last:border-0 rounded-2xl',
}

export default Style